"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function removeJWPlayerInstance(playerId, context) {
  var player = context.jwplayer && context.jwplayer(playerId);

  if (player) {
    player.remove();
  }
}

exports.default = removeJWPlayerInstance;


//////////////////
// WEBPACK FOOTER
// ./~/react-jw-player/dist/helpers/remove-jw-player-instance.js
// module id = 236
// module chunks = 0